/**
 * Round a number to the desired number of decimal places
 * @param value
 * @param decimalPlaces
 */
export const roundToDecimals = (value: number, decimalPlaces: number) => {
  const scale = Math.pow(10, decimalPlaces);
  const promoted = value * scale;
  return Math.round(promoted) / scale;
};
